module Omni.Booker {

    function changeCategoryTitle() {
        return function (category) {
            if (category === "City") {
                category = "City / State";
            }
            return category;
        }
    }
    changeCategoryTitle.$inject = [];
    NgModule.filter("changeCategoryTitle", changeCategoryTitle);

    function searchHighlight($sce) {
        return function (text, phrase, category, city, state, isGha) {
            if (phrase) {
                text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                    '<span class="search-highlight">$1</span>');
                if (category === "Hotel") {
                    var cityHighlighted = city.replace(new RegExp('(' + phrase + ')', 'gi'), '<span class="search-highlight" >$1</span>');
					if (isGha) {
						text = text.concat('<span class="gha-line-break"></span>');
					}
					text = text.concat('<span class="search-highlight-small">' + cityHighlighted + ', ' + state + '</span>');
                    
	                if (isGha) {
                        text = text.concat(' <span class="search-highlight-small gha-search-badge">(DISCOVERY Partner)</span>');
                    }
                }

            }
            return $sce.trustAsHtml(text)
        }
    }
    searchHighlight.$inject = ["$sce"];
    NgModule.filter("searchHighlight", searchHighlight);

    function propertyLabelFilter() {
        return (input, search) => {
            input = input || [];
            var filtered = [];

            for (var i = 0, ct = input.length; i < ct; i++) {
                var item = input[i];
                if (item.label.search(new RegExp(search, 'i')) >= 0) {
                    filtered.push(item);
                }

            }

            return filtered;
        }
    }
    propertyLabelFilter.$inject = [];
    NgModule.filter("omPropertyFilter", propertyLabelFilter);
}